export default {

    requestDesktopNotificationPermission() {
        if (Notification.permission !== 'granted') {
            Notification.requestPermission();
        }
    },

    checkDesktopNotificationStatus() {
        return Notification.permission
    },

    createNotification(title, options) {
        const notification = new Notification(title, options)
        return notification
    }


}